import axios, { AxiosInstance } from "axios";

declare module "axios" {
  export interface AxiosInstance {
    hasSessionToken: () => boolean;
  }
}
const APIBase: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_COBUTLER_API_URL,
  withCredentials: true,
});
APIBase.hasSessionToken = function () {
  if (localStorage.getItem("cobutlerToken")) return true;
  return false;
};
APIBase.interceptors.request.use(
  (config) => {
    const authToken = localStorage.getItem("cobutlerToken");
    config.headers["x-cobutler-session"] = authToken;
    // console.log(`sending API request with token ${authToken}`)
    return config;
  },
  (error) => {
    console.log("API ERROR:", error);
    Promise.reject(error);
  }
);

// interceptor to handle API response errors
APIBase.interceptors.response.use(
  (response) => {
    // if the response is successful, just return it
    // TODO possibly add handling to save an updated access token returned by the API
    return response;
  },
  (error) => {
    // check if the error response status is 401
    if (error.response && error.response.status === 401) {
      console.log(
        "401 received, clearing local cookie and redirecting to login"
      );
      localStorage.removeItem("cobutlerToken");
      localStorage.removeItem("cobutlerTokenExpiry");
      window.location.href = "/login";
    } else {
      console.log("API response error:", error);
    }
    return Promise.reject(error);
  }
);
export default APIBase;
